const CONFIG = {
  REACT_APP_HASURA_HTTP: 'https://gql-jobfinder.lumen.media/v1/graphql',
  // REACT_APP_WEBHOOK_SERVER: 'http://localhost:3000',
  REACT_APP_WEBHOOK_SERVER: 'https://api-auth.praktikumsanzeigen.info',
  //REACT_APP_STUDENTS_APOLLO: 'http://localhost:6060/api/gql'
  REACT_APP_STUDENTS_APOLLO: 'https://apollo-mail.studentsgoabroad.com/api/gql',
  REACT_APP_MAPS_API_KEY: 'AIzaSyCTA-2jcerh1IqUOt2P14RX2OZBn85tgk8'
}
export default CONFIG
